import { Injectable } from '@angular/core'

import {
  HttpResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http'

import { Observable } from 'rxjs'
import { LoaderService } from './loader.service'
import { InterceptorSkipHeader } from '../config/config'

/**
 * LoaderInterceptor
 *
 * @author Jesús Fernández
 *
 * Intercepts http calls to show loading
 */
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  /**
   * @ignore
   */
  private requests: HttpRequest<any>[] = []

  /**
   * @ignore
   */
  constructor(private loaderService: LoaderService) {}

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req)
    if (i >= 0) {
      this.requests.splice(i, 1)
    }
    this.loaderService.isLoading.next(this.requests.length > 0)
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.headers.has(InterceptorSkipHeader)) {
      const headers = req.headers.delete(InterceptorSkipHeader)
      return next.handle(req.clone({ headers }))
    }

    this.requests.push(req)
    this.loaderService.isLoading.next(true)
    return Observable.create((observer) => {
      const subscription = next.handle(req).subscribe(
        (event) => {
          if (event instanceof HttpResponse) {
            this.removeRequest(req)
            observer.next(event)
          }
        },
        (err) => {
          this.removeRequest(req)
          observer.error(err)
        },
        () => {
          this.removeRequest(req)
          observer.complete()
        }
      )
      // teardown logic in case of cancelled requests
      return () => {
        this.removeRequest(req)
        subscription.unsubscribe()
      }
    })
  }
}
